import * as React from 'react'
import type { Plan } from '@/modules/plans/types'
import { Checkbox } from '@/shared/ui/Checkbox'

export default function ExclusiveLinkPlansSelector({ plans, selectedIds, onChange, popularId, onChangePopular }: { plans: Plan[]; selectedIds: string[]; onChange: (ids: string[]) => void; popularId?: string | null; onChangePopular?: (id: string) => void }) {
  const setChecked = (id: string, on: boolean) => {
    const next = new Set(selectedIds);
    if (on) { next.add(id) } else { next.delete(id) }
    onChange(Array.from(next));
  };

  return (
    <div className="space-y-2">
      {plans.map((p) => (
        <label key={p.id} className="flex items-center justify-between rounded-md border p-2 text-sm">
          <div className="flex flex-col">
            <div className="font-medium">{p.name}</div>
            <div className="text-xs text-foreground/60">{p.active ? 'Ativo' : 'Inativo'} - {p.visible ? 'Visivel' : 'Nao visivel'} - {p.interval === 'year' ? 'Anual' : (p.interval === 'month' ? 'Mensal' : p.interval)}</div>
          </div>
          <div className="flex items-center gap-3">
            <label className="flex items-center gap-1 text-xs">
              <input type="radio" name="exclusivePopular" checked={popularId === p.id} onChange={()=> onChangePopular && onChangePopular(p.id)} /> Popular
            </label>
            <Checkbox checked={selectedIds.includes(p.id)} onChange={(e)=> setChecked(p.id, (e.target as HTMLInputElement).checked)} />
          </div>
        </label>
      ))}
      {plans.length === 0 && <div className="text-xs text-foreground/60">Nenhum plano ativo encontrado.</div>}
    </div>
  )
}
